import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { EMPTY_TAGS, TagPicker } from "@/components/teacher/Social";

export const PoolNameDialog = ({ open, onOpenChange, title, initial = "", onSubmit, withTags = false }) => {
  const [name, setName] = useState(initial);
  const [busy, setBusy] = useState(false);
  const [tags, setTags] = useState(EMPTY_TAGS);

  useEffect(() => {
    if (open) { setName(initial); setTags(EMPTY_TAGS); }
  }, [open, initial]);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    try {
      await onSubmit(name.trim(), tags);
      onOpenChange(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[rgba(15,23,42,0.55)] border-[rgba(71,85,105,0.45)]" data-testid="pool-name-dialog">
        <form onSubmit={submit} className="space-y-5">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">{title}</DialogTitle>
          </DialogHeader>
          <div className="space-y-2">
            <Label htmlFor="pool-name">Havuz adı</Label>
            <Input id="pool-name" value={name} maxLength={120} autoFocus onChange={(e) => setName(e.target.value)}
              placeholder="örn. Atom Yapısı" data-testid="pool-name-input" className="h-12 text-lg" />
          </div>
          {withTags && <TagPicker value={tags} onChange={setTags} />}
          <DialogFooter>
            <Button type="submit" disabled={busy || !name.trim()} data-testid="pool-name-submit" className="font-bold">
              Kaydet
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
